import {InnerFilters} from 'types';
import {ProductCardAuditParams} from 'types/product-card-audit';

export const mapProductCardAuditFilters = (filters: InnerFilters): ProductCardAuditParams => {
    const text = (key: string) => {
        const item = filters[key];
        const value = item && typeof item === 'object' && 'value' in item ? item.value : item;
        return typeof value === 'string' ? value.trim() || undefined : undefined;
    };
    const [from, to] = (filters.eventTimestamp as [Date | null, Date | null]) || [];
    const versionText = text('productVersion');
    const version = versionText && /^\d+$/.test(versionText) ? Number(versionText) : undefined;
    return {
        eventId: text('eventId'),
        userRole: text('userRole'),
        search: text('search'),
        sortDesc: filters.sortDesc === undefined ? undefined : filters.sortDesc === 'true',
        userId: text('userId'),
        userFullName: text('userFullName'),
        organizationName: text('organizationName'),
        organizationTin: text('organizationTin'),
        eventType: text('eventType'),
        productCode: text('productCode'),
        productId: text('productId'),
        productVersion:
            version !== undefined && Number.isSafeInteger(version) && version <= 2147483647
                ? version
                : undefined,
        productStatus: text('productStatus'),
        from: from
            ? new Date(from.getFullYear(), from.getMonth(), from.getDate()).toISOString()
            : undefined,
        to: to
            ? new Date(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59, 59, 999).toISOString()
            : undefined,
    };
};
